export const constants = {
  mainPhone: {
    value: "+37069557786",
    formattedValue: "+370 695 57786",
  },
}
